import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Wallet, User, ShieldCheck, Heart, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";

export default function Account() {
  const { user } = useAuth();

  return (
    <div className="max-w-4xl mx-auto px-6 py-12" data-testid="account-page">
      <div className="border-b border-black/10 pb-8 mb-8">
        <div className="font-mono text-xs text-[#FF3B30] tracking-widest">MY ACCOUNT</div>
        <h1 className="font-display text-6xl tracking-tighter mt-2">{user?.name?.toUpperCase()}</h1>
        <p className="text-black/50 mt-2 font-mono text-sm">{user?.email}{user?.phone ? ` · +91 ${user.phone}` : ""}</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-8">
        <div className="border border-black/15 p-6">
          <div className="font-mono text-xs text-black/50 tracking-widest flex items-center gap-2"><Wallet size={14} /> ELMNTS WALLET</div>
          <div className="font-display text-6xl tracking-tighter text-[#FF3B30] mt-2">{user?.wallet_points || 0}</div>
          <div className="text-xs font-mono text-black/40 mt-1">POINTS · ₹1 = 1 POINT @ CHECKOUT</div>
        </div>
        <div className="border border-black/15 p-6">
          <div className="font-mono text-xs text-black/50 tracking-widest flex items-center gap-2"><ShieldCheck size={14} /> MEMBERSHIP</div>
          <div className="font-display text-4xl tracking-tighter mt-2">{user?.member_tier?.toUpperCase() || "FREE"}</div>
          <div className="text-xs font-mono text-black/40 mt-1">Spend ₹15,000 to unlock ELITE tier</div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <Link to="/orders" className="border border-black/15 p-6 hover:border-black transition-colors" data-testid="account-orders">
          <ShoppingBag size={22} className="text-[#FF3B30]" />
          <div className="font-display tracking-widest text-sm mt-3">MY ORDERS</div>
          <div className="text-xs font-mono text-black/40 mt-1">View, track, return</div>
        </Link>
        <Link to="/wishlist" className="border border-black/15 p-6 hover:border-black transition-colors" data-testid="account-wishlist">
          <Heart size={22} className="text-[#FF3B30]" />
          <div className="font-display tracking-widest text-sm mt-3">WISHLIST</div>
          <div className="text-xs font-mono text-black/40 mt-1">Saved styles</div>
        </Link>
        <div className="border border-black/15 p-6">
          <User size={22} className="text-[#FF3B30]" />
          <div className="font-display tracking-widest text-sm mt-3">REFER & EARN</div>
          <div className="text-xs font-mono text-black/40 mt-1">Give ₹500, get ₹500</div>
          <div className="mt-2 text-xs font-mono text-black truncate">CODE: {user?.email?.split("@")[0]?.toUpperCase()}500</div>
        </div>
      </div>
    </div>
  );
}
